import { useMediaQuery } from 'react-responsive';

const useResponsive = () => {
  const isDesktop = useMediaQuery({ minWidth: 1280 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1279 });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return { isDesktop, isTablet, isMobile };
};

export default useResponsive;